import React from "react";
import { cn } from "../../lib/cn";
import { Eyebrow } from "./Eyebrow";
import { Heading } from "./Heading";

/**
 * Page/section header block: eyebrow + heading + optional description and actions.
 *   <SectionHeader eyebrow="Members" title={<>All <em className="kbc-serif">members</em></>}
 *                  description="..." actions={<Button/>} />
 */
export function SectionHeader({ eyebrow, title, description, actions, align = "left", variant = "section", className }) {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 md:flex-row md:items-end md:justify-between",
        align === "center" && "items-center text-center md:flex-col md:items-center",
        className
      )}
    >
      <div className={cn("space-y-3", align === "center" && "mx-auto")}>
        {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
        {title && <Heading variant={variant}>{title}</Heading>}
        {description && <p className="max-w-prose text-[1.02rem] leading-relaxed text-text">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-3">{actions}</div>}
    </div>
  );
}

/** Vertical rhythm wrapper. */
export function Section({ className, children, ...props }) {
  return (
    <section className={cn("py-10 sm:py-14", className)} {...props}>
      {children}
    </section>
  );
}

export default Section;
